import events from '../constants/events';
import { dispatchEvent } from './customEvents';

export const ajaxUpdate = (url, options = {}) => {
  const defaults = {
    body: null,
    callback: null,
    history: true,
    method: 'GET',
    precallback: null,
    selectors: [],
    headers: {}
  }

  const combinedOptions = Object.assign({}, defaults, options);

  const ajaxingClass = 'ajaxing';
  const body = document.body;

  body.classList.add(ajaxingClass);

  fetch(url, {
    body: combinedOptions.body,
    method: combinedOptions.method,
    headers: {
      Pragma: 'no-cache',
      ...combinedOptions.headers,
    }
  })
  .then((response) => response.text())
  .then((html) => {
    let parser, htmlDocument;

    // Parse returned text to HTML
    if (combinedOptions.selectors.length > 0) {
      parser = new DOMParser();
      htmlDocument = parser.parseFromString(html, 'text/html');
    }

    // Call precallback function
    if (combinedOptions.precallback) {
      combinedOptions.precallback();
    }

    // Replace selected elements
    combinedOptions.selectors.forEach((selector) => {
      let currentElement;
      let targetElement;

      if (typeof selector === 'string' || selector instanceof String) {
        currentElement = document.querySelector(selector);
        targetElement = htmlDocument.documentElement.querySelector(selector);
      } else {
        currentElement = document.querySelector(selector.current);
        targetElement = htmlDocument.documentElement.querySelector(selector.target);
      }

      if (currentElement && targetElement) {
        currentElement.innerHTML = targetElement.innerHTML;
      }
    });

    // Handle history
    if (combinedOptions.history && window.history) {
      const title = htmlDocument.body.dataset.title;

      if (title) {
        document.title = title;
      }

      window.history.replaceState({ path: url }, '', url);
    }

    // Call callback function
    if (combinedOptions.callback) {
      combinedOptions.callback();
    }

    // Dispatch ajax updated event
    dispatchEvent(window, events.AJAX_UPDATED, {
      selectors: combinedOptions.selectors
    });

    body.classList.remove(ajaxingClass);
  })
  .catch((err) => {
    // Handle the error
    body.classList.remove(ajaxingClass);
  });
};
